<template>
  <!-- <div class="header_right">
    <div class="right_item">
      <span class="right_title">销量分布</span>
      <div class="right_content">
        <img
          src="~@/assets/image/旋转地球.gif"
          alt=""
          style="width: 100%; height: 100%"
        />
      </div>
    </div>
    <div class="right_item">
      <span class="right_title">实时订单情况</span>
      <div class="right_content list_wamp">
        <ul class="list">
          <li v-for="(item, index) in header" :key="index">
            {{ item.display_name }}
          </li>
        </ul>
        <ul class="list_two">
          <li v-for="(item, index) in list" :key="index">
            <div v-for="(value, key) in item" :key="key">
              {{ value }}
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div> -->
</template>

<script>
export default {
  name: "HeaderRight",
  mounted() {
    // let url = `/card/${this.$apiObj.rightList}`;
    let timer = setInterval(() => {
      if (this.$url.length > 0) {
        clearInterval(timer);
        let url = `${this.$url}${this.$apiObj.rightList}`;
        this.$axios.get(url).then((res) => {
          let datas = res.data.data;
          this.list = datas.rows; // all order list
          this.header = datas.cols;
        });
      }
    });

    setInterval(() => {
      this.scroll();
    }, 2000);
  },
  data() {
    return {
      list: [],
      header: [],
      height: 0,
      li_height: 0,
    };
  },
  methods: {
    scroll() {
      // ul 的高度 然后滚动 滚动到 ul的高度是 数据进行刷新
      let ul_height = document.querySelectorAll(".list_two")[0].clientHeight; //  ul 的高度
      this.li_height = document
        .querySelectorAll(".list_two")[0]
        .querySelectorAll("li")[0].clientHeight; // li 的高度 滚动的距离
      if (this.height >= ul_height - 100) {
        // let url = `${this.$url}${this.$apiObj.rightList}`;
        let url = `/card/${this.$apiObj.rightList}`;
        this.$axios.get(url).then((res) => {
          let datas = res.data.data;
          this.list = datas.rows; // all order list
          this.header = datas.cols;
        });
        this.height = 0;
      }
      document.querySelectorAll(
        ".list_two"
      )[0].style.transform = `translate(0,${-this.height}px)`;
      this.height += this.li_height;
    },
  },
};
</script>

<style lang="less">
.header_right {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  .right_item {
    // background: url("~@/assets/image/线框2.png") no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 45%;
    position: relative;
    z-index: 999;
    text-align: center;
    .right_title {
      color: white;
      font-size: 1.5rem;
    }
    .right_content {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      top: 0;
      margin: auto;
      z-index: -1;
      overflow: hidden;
      img {
        opacity: 0.4;
      }
    }
    .list_wamp {
      width: 93%;
      height: 80%;
      .list {
        display: flex;
        justify-content: space-around;
        background: rgb(0, 26, 45);
        position: relative;
        z-index: 999;
        li {
          color: white;
          flex: 1;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      .list_two {
        transition: all 2s;
        li:nth-child(2n) {
          background: rgb(49, 78, 105);
        }
        li {
          display: flex;
          justify-content: space-around;
          div {
            flex: 1;
            color: white;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            padding: 0.3125rem;
          }
        }
      }
    }
  }
}
</style>